import { AppStateType } from '../reducers'
import { IDataChartData } from '../types/datachart'

export const selectDataChart = ({ datachart }: AppStateType): IDataChartData =>
  datachart
